import React from "react";
import Noticeboard from "./HR/Noticeboard/Noticeboard";

export default function NoticeboardPage() {
  return (
    <div className="px-6 space-y-6 animate-in fade-in duration-300">
      <Noticeboard />
    </div>
  );
}
